import React from "react";
import { Box, Button, Dialog, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

type Props = {
  onClose: () => void;
  open: boolean;
  status: "accepted" | "declined" | undefined;
};

export const Modal: React.FC<Props> = (props) => {
  const history = useHistory();

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <Box padding={7} alignItems="center">
        <Typography variant="body1">
          {props.status === "accepted"
            ? "Accept Successful"
            : props.status === "declined"
            ? "The Attestation has been Declined"
            : "Please Accept/Decline Attestation"}
        </Typography>
        <Box mt={2} textAlign="center">
          <Button
            onClick={() => {
              if (props.status) {
                history.push(`/dashboard/my-request`);
              } else {
                props.onClose();
              }
            }}
            color="primary"
            variant="outlined"
          >
            {props.status ? "Ok" : "Got It"}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
